export { default as RichText, type RichTextProps } from './RichText';
